import ManageEquipmentTable from './ManageEquipmentTable'

const ManageEquipment = {
  Table: ManageEquipmentTable,
}

export default ManageEquipment
